var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-datatable',{attrs:{"title":_vm.textTitle,"headers":_vm.headers,"create-enabled":_vm.$global.roles.isAdmin()},on:{"rowclicked":(e) => _vm.$emit('rowclicked', e),"create":() => _vm.$emit('create')},model:{value:(_vm.appusers),callback:function ($$v) {_vm.appusers=$$v},expression:"appusers"}})
}
var staticRenderFns = []

export { render, staticRenderFns }